import { SummaryItemType } from "@/types/business/item.type";
import { CategoryType, TaxType } from "@/types/categories/category.type";

interface CategoryInterface {}
/***
 * Category module
 */
class Category implements CategoryInterface {
  readonly id: string = "";
  name: string = "";
  local_name?: string = "";
  created_at?: Date = new Date();
  updated_at?: Date = new Date();
  image?: any = null;
  is_active?: boolean;
  taxes?: Array<TaxType> = [];
  category_items?: Array<SummaryItemType> | Array<any>;
  is_system?: boolean;
  comments?: string = "";

  public static readonly MODULE_NAME: string = "catalog/category";

  constructor(data: CategoryType) {
    if (data) {
      this.id = data.id || "";
      this.name = data.name;
      this.local_name = data.local_name || "";
      this.created_at = data.created_at || new Date();
      this.updated_at = data.updated_at || new Date();
      this.image = data.image || null;
      this.is_active = data.is_active || true;
      this.taxes = data.taxes || [];
      this.category_items = data.category_items || [...category_items_array];
      this.is_system = data.is_system || false;
      this.comments = data?.comments || "";
    }
  }

  public removeImage() {
    delete this.image;
  }
}

export default Category;

const category_items_array = [
  {
    id: "46ef7029-2d31-46cf-beee-30e09ae42696",
    name: "Pepsi",
    image: "https://www.nicepng.com/png/detail/75-757309_pepsi-can-lata-pepsi-png.png",
  },
  {
    id: "46ef7029-2d31-46cf-beee-30e09ae42696",
    name: "Latte",
    image: "https://www.caffesociety.co.uk/assets/recipe-images/latte-small.jpg",
  },
  {
    id: "46ef7029-2d31-46cf-beee-30e09ae42696",
    name: "Burger",
    image: "https://cdn.imgbin.com/13/21/10/imgbin-delicious-beef-burger-9RtjmvJf4vM9qKWdixsgzRqb6.jpg",
  },
  {
    id: "46ef7029-2d31-46cf-beee-30e09ae42696",
    name: "Meet",
    image: "https://cdn.cdkitchen.com/images/cats/2231/cat-2231-720-1.jpg",
  },
];
